<template>
  <div class="app-container">
    <el-card class="export-card">
      <div class="back-button-container">
        <el-button type="primary" icon="el-icon-arrow-left" @click="goBack" size="small">返回上一页</el-button>
      </div>
      <div class="hint-box">
        <div>注意：</div>
        <p> 1.为了数据完整，下载的文件只保留3天的有限期，过了就自动删除记录和文件。请早些下载！<br />
          2.导出表格如果等待时间太长，可以关闭标签页，或关闭浏览器，下载完成后即可直接下载文件</p>
      </div>
      <el-alert
        v-if="!query.codes"
        title="缺少导出类型，请从对应业务页面重新进入"
        type="warning"
        :closable="false"
        show-icon />
      <div :key="exportContextKey" class="filter-container">
        <meeting-sign-up-vue v-if="query.codes === 'EEForMeetSignUp'" @created="doQueryList({pageNo:1})" />
        <goods-list-vue v-if="query.codes === 'ExportSysGoods'" @created="doQueryList({pageNo:1})" :isIntegral="isIntegral" />
        <course-topic-vue v-if="query.codes === 'ExportCourseTopic'" @created="doQueryList({pageNo:1})" />
        <exam-records-vue v-if="query.codes === 'ExportExamRecords'" @created="doQueryList({pageNo:1})" />
        <pass-records-vue v-if="query.codes === 'ExportBarrierRecords'" @created="doQueryList({pageNo:1})" />
        <technical-manage-vue v-if="query.codes === 'EEForTechInfo'" @created="doQueryList({pageNo:1})" />
        <reservation-vue v-if="query.codes === 'EEForTechServiceOrder'" @created="doQueryList({pageNo:1})" />
        <indicator-vue v-if="query.codes === 'EEForTechInfoQuota'" @created="doQueryList({pageNo:1})" />
        <city-corporation-vue v-if="query.codes === 'ExportCityCompanyDownload'" @created="doQueryList({pageNo:1})" />
        <business-audit-vue v-if="query.codes === 'FinanceExportDownloadExcel'" @created="doQueryList({pageNo:1})" />
        <discount-modification-audit-vue v-if="query.codes === 'DiscountModificationAuditExport'" @created="doQueryList({pageNo:1})" />
        <invoice-application-audit-vue v-if="query.codes === 'downloadCustomerOrderInvoiceList'" @created="doQueryList({pageNo:1})" />
        <recharge-manual-ledger-audit-vue v-if="query.codes === 'RechargeManualLedgerAuditExport'" @created="doQueryList({pageNo:1})" />
        <account-vue v-if="query.codes === 'manageFinanceAccountDownloadExcel'" @created="doQueryList({pageNo:1})" />
        <account-refund-detail-vue v-if="query.codes === 'manageFinanceRefundDetailDownloadExcel'" @created="doQueryList({pageNo:1})" />
        <clue-vue v-if="query.codes === 'EEForMyClue'" :cueType="cueType" @created="doQueryList({pageNo:1})" />
        <order-vue v-if="query.codes === 'ExportCustomerOrder,ExportCustomerOrderGoods' || query.codes === 'ExportCustomerPointOrder,ExportCustomerPointOrderGoods'" :orderType="orderType" @created="doQueryList({pageNo:1})" />
        <education-company-vue v-if="query.codes === 'educationDownloadExcel' || query.codes === 'educationCourserOrMeetingExport'" :commissionSource="commissionSource" @created="doQueryList({pageNo:1})" />
        <client-vue v-if="query.codes === 'CustomerDownloadExcelDiy3'" @created="doQueryList({pageNo:1})" />
        <customer-follow-up-vue v-if="query.codes === 'EEForCustomerFollowUp'" @created="doQueryList({pageNo:1})" />
        <business-vue v-if="query.codes === 'CustomerDownloadExcelDiy2'" @created="doQueryList({pageNo:1})" />
        <business-statistics-vue v-if="query.codes === 'CustomerDownloadYWPer'" @created="doQueryList({pageNo:1})" />
        <teacher-statistics-vue v-if="query.codes === 'listForStatisticsDown'" :isServiceTeacher="isServiceTeacher" @created="doQueryList({pageNo:1})" />
        <goods-statistics-vue v-if="query.codes === 'NaHuoStatisticsExportExcel'" @created="doQueryList({pageNo:1})" />
        <after-order-vue v-if="query.codes === 'ExportOrderAfterExport'" @created="doQueryList({pageNo:1})" />
        <!--待认领售后订单导出-->
        <after-order-claim-vue v-if="query.codes === 'EEForAfterOrderOther'" @created="doQueryList({pageNo:1})" />
        <company-sales-vue v-if="query.codes === 'ExportCityCompanyTotalDownloadExcel'" @created="doQueryList({pageNo:1})" />
        <afterSales-vue v-if="query.codes === 'findAfterTotalExportByQuery'" @created="doQueryList({pageNo:1})" />
        <course-ranking-vue v-if="query.codes === 'ExportCourseRanking'" @created="doQueryList({pageNo:1})" />
        <study-record-vue v-if="query.codes === 'ExportStudyRecord'" @created="doQueryList({pageNo:1})" />
        <change-order-vue v-if="query.codes === 'exchangeOrderExport'" @created="doQueryList({pageNo:1})" />
        <course-order-vue v-if="query.codes === 'ExportCourseOrder'" @created="doQueryList({pageNo:1})" />
        <recharge-record-vue v-if="query.codes === 'tuitionListExport'" @created="doQueryList({pageNo:1})" />
        <!-- 订单对账 -->
        <reconciliation-order v-if="query.codes === 'ExportCustomerOrderReconciliation'" @created="doQueryList({pageNo:1})" />
        <!-- 课程订单对账 -->
        <course-order-reconciliation v-if="query.codes === 'ExportCourseOrderReconciliation'" @created="doQueryList({pageNo:1})" />
        <!-- 付款凭证导出 -->
        <voucher-vue v-if="query.codes === 'registrationExport'" @created="doQueryList({pageNo:1})" />
        <!-- 升级礼包导出 -->
        <registration-gift-vue v-if="query.codes === 'registrationGiftExport'" @created="doQueryList({pageNo:1})" />
        <!-- 充值礼包导出 -->
        <recharge-gift-vue v-if="query.codes === 'EEForRechargeGift'" @created="doQueryList({pageNo:1})" />
        <!-- 直播间观看人数导出 -->
        <live-view-statistics-vue v-if="query.codes === 'downloadStatisticsByLive'" @created="doQueryList({pageNo:1})" />
        <!-- 直播间大区统计导出 -->
        <live-area-statistics-vue v-if="query.codes === 'downloadStatisticsAreaByLive'" @created="doQueryList({pageNo:1})" />
        <!-- 打赏记录导出 -->
        <live-reward-order-vue v-if="query.codes === 'ExportLiveRewardOrder'" @created="doQueryList({pageNo:1})" />
        <!-- 大客户导出 -->
        <customer-big v-if="query.codes === 'EEForCustomerBig'" @created="doQueryList({pageNo:1})" />
        <!-- 登录日志导出 -->
        <login-log-vue v-if="query.codes === 'exportLoginLog'" @created="doQueryList({pageNo:1})" />
        <!-- 继承/开发客户 -->
        <customer-inherit v-if="query.codes === 'CustomerDownloadExcelDiy99'" @created="doQueryList({pageNo:1})" />
        <order-performance-vue v-if="query.codes === 'OrderPerformanceExport'" @created="doQueryList({pageNo:1})" />
        <!-- 物料分析导出导出 -->
        <export-materials-share-analyze-vue v-if="query.codes === 'ExportMaterialsShareAnalyze'" @created="doQueryList({pageNo:1})" />
        <!-- 折扣修改审核导出 -->
        <discount-modification-audit-vue v-if="query.codes === 'downloadChangProfitRatio'" @created="doQueryList({pageNo:1})" />
        <!-- 学费订单V2导出 -->
        <tuition-order-v2-vue v-if="query.codes === 'EEForTuitionOrderV2'" @created="doQueryList({pageNo:1})" />
        <!-- 收款明细对账（全量）导出 -->
        <all-payment-reconciliation-vue v-if="query.codes === 'allPaymentExport'" @created="doQueryList({pageNo:1})" />
        <!-- 教培数据统计（REQ-2026-125349）三个导出共用一个筛选组件 -->
        <edu-stats-vue v-if="['EEForEduTeacherStats','EEForEduCustomerStats','EEForEduNewCustomerStats'].includes(query.codes)" :code="query.codes" @created="doQueryList({pageNo:1})" />
        <!-- 子账号回访导出（REQ-2026-601171） -->
        <child-followup-vue v-if="query.codes === 'EEForChildFollowup'" @created="doQueryList({pageNo:1})" />
        <!-- 大客户看板（REQ-2026-107511）周报 / 明细两个导出 -->
        <big-customer-board-vue v-if="['EEForBigCustomerWeekly','EEForBigCustomerDetail'].includes(query.codes)" :code="query.codes" @created="doQueryList({pageNo:1})" />

      </div>
      <div class="refresh">下载记录<el-button
        type="primary"
        @click="handleQuery"
        :disabled="!query.codes"
        size="mini"
        icon="el-icon-refresh-right">刷新</el-button></div>
      <el-table v-loading="listLoading" :data="list" @sort-change="sortChange">
        <el-table-column label="文件名称" prop="title" align="center" />
        <el-table-column label="状态" prop="speed" align="center">
          <template slot-scope="{row}">
            <span v-if="row.state === 2">
              导出失败
              <el-tooltip v-if="row.errorLog" :content="row.errorLog" placement="top">
                <i class="el-icon-question" style="color: #f56c6c; margin-left: 5px; cursor: pointer;"></i>
              </el-tooltip>
            </span>
            <el-progress v-else :percentage="row.speed" :text-inside="true" :stroke-width="15"></el-progress>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="createdTime" align="center" />
        <el-table-column label="导出人" prop="operatedName" align="center" />
        <el-table-column label="操作" prop="activityName" align="center">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleDownload(row)" v-if="row.speed === 100 && row.state === 1">下载</el-button>
            <el-button type="text" @click="showErrorLog(row)" v-else-if="row.state === 2">
              导出失败
              <el-tooltip v-if="row.errorLog" :content="row.errorLog" placement="top">
                <i class="el-icon-question" style="color: #f56c6c; margin-left: 5px; cursor: pointer;"></i>
              </el-tooltip>
            </el-button>
            <el-button type="text" v-else @click="handleDownload(row)">生成中</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="total>0"
        :total="total"
        :pageNo.sync="query.pageNo"
        :pageSize.sync="query.pageSize"
        @pagination="doQueryList" />
    </el-card>
  </div>
</template>

<script>
import sysTaskApi from '@/api/sys/sysTask'
import meetingSignUpVue from './meetingSignUp.vue'
import goodsListVue from './goodsList.vue'
import courseTopicVue from './courseTopic.vue'
import examRecordsVue from './examRecords.vue'
import passRecordsVue from './passRecords.vue'
import technicalManageVue from './technicalManage.vue'
import reservationVue from './reservation.vue'
import indicatorVue from './indicator.vue'
import cityCorporationVue from './cityCorporation.vue'
import businessAuditVue from './businessAudit.vue'
import discountModificationAuditVue from './discountModificationAudit.vue'
import invoiceApplicationAuditVue from './invoiceApplicationAudit.vue'
import rechargeManualLedgerAuditVue from './rechargeManualLedgerAudit.vue'
import accountVue from './account.vue'
import accountRefundDetailVue from './accountRefundDetail.vue'
import clueVue from './clue.vue'
import orderVue from './order.vue'
import educationCompanyVue from './educationCompany.vue'
import clientVue from './client.vue'
import customerFollowUpVue from './customerFollowUp.vue'
import businessVue from './business.vue'
import businessStatisticsVue from './businessStatistics.vue'
import teacherStatisticsVue from './technicalStatistics.vue'
import goodsStatisticsVue from './goodsStatistics.vue'
import companySalesVue from './companySales.vue'
import afterSalesVue from './afterSales.vue'
import courseRankingVue from './courseRanking.vue'
import studyRecordVue from './studyRecord.vue'
import afterOrderVue from './afterOrder.vue'
import afterOrderClaimVue from './afterOrderClaim.vue'
import changeOrderVue from './changeOrder.vue'
import courseOrderVue from './courseOrder.vue'
import rechargeRecordVue from './rechargeRecord.vue'
import reconciliationOrder from '../reconciliation/order.vue'
import courseOrderReconciliation from '../reconciliation/courseOrder.vue'
import voucherVue from '../reconciliation/voucher.vue'
import registrationGiftVue from '../reconciliation/registrationGift.vue'
import rechargeGiftVue from '../reconciliation/rechargeGift.vue'
import liveViewStatisticsVue from '../reconciliation/liveViewStatistics.vue'
import liveRewardOrderVue from '../reconciliation/liveRewardOrder.vue'
import customerBig from '../reconciliation/customerBig.vue'
import loginLogVue from '../reconciliation/loginLog.vue'
import customerInherit from '../reconciliation/customerInherit.vue'
import liveAreaStatisticsVue from '../reconciliation/liveAreaStatistics.vue'
import orderPerformanceVue from '../reconciliation/orderPerformance.vue'
import exportMaterialsShareAnalyzeVue from './ExportMaterialsShareAnalyze.vue'
import tuitionOrderV2Vue from './tuitionOrderV2.vue'
import allPaymentReconciliationVue from './allPaymentReconciliation.vue'
import eduStatsVue from './eduStats.vue'
import childFollowupVue from './childFollowup.vue'
import bigCustomerBoardVue from './bigCustomerBoard.vue'
export default {
  components: {
    meetingSignUpVue,
    goodsListVue,
    courseTopicVue,
    examRecordsVue,
    passRecordsVue,
    technicalManageVue,
    reservationVue,
    indicatorVue,
    cityCorporationVue,
    businessAuditVue,
    discountModificationAuditVue,
    invoiceApplicationAuditVue,
    rechargeManualLedgerAuditVue,
    accountVue,
    accountRefundDetailVue,
    clueVue,
    orderVue,
    educationCompanyVue,
    clientVue,
    customerFollowUpVue,
    businessVue,
    businessStatisticsVue,
    teacherStatisticsVue,
    goodsStatisticsVue,
    companySalesVue,
    afterSalesVue,
    courseRankingVue,
    studyRecordVue,
    afterOrderVue,
    afterOrderClaimVue,
    changeOrderVue,
    courseOrderVue,
    rechargeRecordVue,
    reconciliationOrder,
    courseOrderReconciliation,
    voucherVue,
    registrationGiftVue,
    rechargeGiftVue,
    liveViewStatisticsVue,
    liveRewardOrderVue,
    customerBig,
    loginLogVue,
    customerInherit,
    liveAreaStatisticsVue,
    orderPerformanceVue,
    exportMaterialsShareAnalyzeVue,
    tuitionOrderV2Vue,
    allPaymentReconciliationVue,
    eduStatsVue,
    childFollowupVue,
    bigCustomerBoardVue
  },
  data() {
    return {
      dateTime: [],
      activityType: undefined,
      list: [],
      total: 0,
      listLoading: false,
      exportContextKey: '',
      queryRevision: 0,
      queryRequestId: 0,
      query: {
        pageNo: 1,
        pageSize: 10,
        createdTimeSortSign: -1,
        codes: null
      },
      isIntegral: 0,
      cueType: null,
      orderType: 1,
      commissionSource: null,
      isServiceTeacher: 0
    }
  },
  watch: {
    '$route.query': {
      handler(params) {
        this.applyRouteQuery(params || {})
      },
      immediate: true
    }
  },
  beforeDestroy() {
    this.queryRevision++
  },
  methods: {
    applyRouteQuery(params) {
      const { code, isIntegral, cueType, orderType, commissionSource, isServiceTeacher } = params
      const context = JSON.stringify(Object.keys(params).sort().map(key => [key, params[key]]))
      if (context === this.exportContextKey) return
      this.exportContextKey = context
      this.queryRevision++
      this.query = { pageNo: 1, pageSize: 10, createdTimeSortSign: -1, codes: typeof code === 'string' && code.trim() ? code : null }
      this.list = []
      this.total = 0
      this.listLoading = false
      this.isIntegral = isIntegral ? +isIntegral : 0
      this.cueType = code === 'EEForMyClue' ? cueType : null
      this.orderType = orderType ? +orderType : 1
      this.commissionSource = commissionSource || null
      this.isServiceTeacher = +isServiceTeacher || 0
      if (this.query.codes) this.doQueryList({ pageNo: 1 })
    },
    goBack() {
      this.$router.go(-1)
    },
    sortChange({
      prop,
      order
    }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({
        pageNo: 1
      })
    },
    /**
     * 执行列表查询
     */
    doQueryList({
      pageNo,
      pageSize
    }) {
      if (!this.query.codes) {
        this.list = []
        this.total = 0
        this.listLoading = false
        return Promise.resolve()
      }
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }

      const params = JSON.parse(JSON.stringify(this.query))
      if (!params.createdTimeSortSign && !params.operatedTimeSortSign) {
        params.createdTimeSortSign = -1
      }
      if (this.query.codes === 'listForStatisticsDown') {
        params.codes = this.isServiceTeacher ? 'EEForTechInfoDataStatisticsBig' : 'EEForTechInfoDataStatistics'
      }

      this.listLoading = true
      const revision = this.queryRevision
      const requestId = ++this.queryRequestId
      return sysTaskApi.fetchList(params)
        .then(data => {
          if (revision !== this.queryRevision || requestId !== this.queryRequestId) return
          this.list = data.data.list
          this.total = data.data.total
        })
        .finally(() => {
          if (revision === this.queryRevision && requestId === this.queryRequestId) this.listLoading = false
        })
    },
    handleDownload(row) {
      if (!row.taskResponse) return
      const obj = JSON.parse(row.taskResponse)
      const {
        fileUrl,
        fileName
      } = obj
      fetch(fileUrl).then(_ => _.blob()).then(_ => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(_);
        console.log('fileName: ', fileName);
        link.setAttribute('download', fileName);
        link.click();
      })
    },
    showErrorLog(row) {
      if (row.errorLog) {
        this.$alert(row.errorLog, '导出失败原因', {
          confirmButtonText: '确定',
          type: 'error'
        })
      } else {
        this.$message.error('导出失败，暂无详细错误信息')
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.export-card {
  position: relative;
}

.back-button-container {
  position: absolute;
  top: 83px;
  right: 20px;
  z-index: 10;
}

.hint-box {
  border: 1px solid #5dbde7;
  font-size: 14px;
  color: #6c6c6c;

  div {
    background: #5dbde7;
    border: 1px solid #1596cd;
    padding: 13px 23px;
    color: #fff;
  }

  p {
    padding: 0 18px;
    line-height: 22px;
  }
}

.filter-container {
  text-align: center;
  background: #eff8fd;
  margin-top: 30px;
  padding-top: 10px;

  .el-form-item {
    margin-bottom: 0;
  }
}

.refresh {
  font-size: 14px;
  background: #eff8fd;
  margin-top: 30px;
  border-bottom: 1px solid #ebeef5;
  padding: 10px 15px 10px 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
